if (!customElements.get('quick-shuffle')) {
  class QuickShuffle extends HTMLElement {
    constructor() {
      super();
      this.selectedProduct = null;
      this.selectedSize = null;
      this.selectedLength = null;
      this.selectedColor = null;
      this.selectedQty = null;
    }
    
    connectedCallback() {

    this.querySelectorAll('video').forEach(video => {
        video.play()
    });
      this.products = JSON.parse(this.dataset.productsJson.replace("}]},]", "}]}]")
        .replaceAll('%27', '&apos;')
        .replaceAll('%22', '&quot;')
        );
      this.baseProduct = this.products.find(product => product.tags.find(x => x === 'base_product')) ?? null;
      this.selectedProduct = this.products.find(({ handle }) => this.dataset.initialProduct.handle === handle);
      const initialProductId = this.querySelector('input[data-product-id]:checked')?.dataset?.productId;
            
      if (this.selectedProduct?.id === this.baseProduct?.id || !this.selectedProduct) {
        this.selectedProduct = this.products.find(x => x.id === initialProductId);
      }
  
      const thisOptionSet = [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')].map(({ value }) => value);
      this.currentVariant = this.selectedProduct.variants.find(({ options }) => options.every((x) => thisOptionSet.find((y) => y === x)));
      if (!this.currentVariant) {
        this.currentVariant = this.selectedProduct.variants.find(({ available }) => available);
        if (!this.currentVariant) {
          this.currentVariant = this.selectedProduct.variants[0];
        }
      } 

      this.addDelegatedClickListeners();
      this.createCustomEvents();

      this.imagesWrapper = this.querySelector('[data-quickbuy-gallery]');
      this.displayPrice = [...this.querySelectorAll('[data-display-price]')];
      this.displayOptions = this.querySelector('[data-display-options]');
      this.displayTitle = [...this.querySelectorAll('[data-display-title]')];
      this.displayColor = [...this.querySelectorAll('[data-display-color]')];
      this.displaySku = [...this.querySelectorAll('[data-display-sku]')];
      this.mainSelect = this.querySelector('[data-main-select]');
      this.moreInfo = this.querySelector('[data-more-info]');
      this.enableOrDisableOptionSelects();
      this.swapOutATC();

      this.trackHistory(this.selectedProduct.handle);
    }


    addDelegatedClickListeners() {
      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-action]');
        const currentUrl = new URL(window.location.href); 
        let variantUrl;
        const params = new URLSearchParams(currentUrl.search);
        if (!clickedElement) return;
        
        const {
          action,
          productId,
          option,
          optionType,
        } = clickedElement.dataset;
                  
        switch (action) {
          case 'product-select':
            if (productId === this.selectedProduct?.id) return;
            
            if (this.selectedQty) {
              const qtyMatch = this.products.find(({ id, tags }) => {
                return id === productId && tags.find(x => x.includes('quantity:'))?.replace('quantity:', '') === this.selectedQty;
              });
              if (qtyMatch) {
                this.selectedProduct = qtyMatch;
              } else this.selectedProduct = this.products.find(({ id }) => id === productId);
            } else this.selectedProduct = this.products.find(({ id, tags }) => id === productId);
            
            if (this.selectedSize && this.selectedLength) {
              this.currentVariant = this.selectedProduct.variants
                .find(({ options }) => (options.find((x) => x === this.selectedSize) && options.find((x) => x === this.selectedLength)))
            } else if (this.selectedSize) {
              this.currentVariant = this.selectedProduct.variants
                .find(({ options }) => options.find((x) => x === this.selectedSize));
            } else {
              this.currentVariant = this.selectedProduct.variants
                .find(({ default_selected }) => default_selected);
            }
            if (!this.currentVariant) {
              this.currentVariant = this.selectedProduct.variants.find(({ available }) => available);
              if (!this.currentVariant) {
                this.currentVariant = this.selectedProduct.variants[0];
              }
            }
            
            const titleArray = this.selectedProduct.title.split('-');
            const productColor = titleArray.pop().replaceAll('&apos;', `'`).replaceAll('&quot;', `"`);
            const newSwatch = document.querySelector(`img[alt="${productColor}"`);
            this.displayTitle.forEach(title => title.innerHTML = titleArray.join('-'));
            this.displayColor.forEach(color => color.classList.add('hidden'));
            this.displayColor.forEach(color => color.innerHTML = productColor);
            this.moreInfo.setAttribute('href', this.selectedProduct.url);
            this.querySelector(`[data-action="product-select"][data-product-id="${this.selectedProduct.id}"]`)
              .closest('[data-color-group]')?.querySelector('[data-display-color]')?.classList.remove('hidden');
            
            this.populateSelectedProductPrice();
            this.populateSelectedProductOptions();
            this.enableOrDisableOptionSelects();
            this.populateSelectedProductImages();
            this.swapOutATC();

            [...document.querySelectorAll('[data-show]')].forEach((el) => {
              if (el.dataset.show === this.selectedProduct.id) {
                el.style.display = null;
                if (el.closest('swiper-carousel')) {
                  el.closest('swiper-carousel').swiper.update();
                }
                return;
              }
              el.style.display = 'none';
            });
            
            if (!this.currentVariant) return;            
            this.displaySku.forEach(sku => sku.innerHTML = this.currentVariant.sku.split('|')[0]);
            this.mainSelect.innerHTML = `${this.selectedProduct.variants.map((variant) => `
              <option 
                value="${variant.id}"
                ${variant.id === this.currentVariant?.id ? 'selected="selected"' : ''}
              >
                ${variant.title} - ${variant.price_money}
              </option>
            `).join('')}`;
            
          break;
          case 'option-choice':
            if (!option) {
              console.error('Input with [data-action="option-choice"] is missing a [data-option="value"] attr');
              return;
            }

            const optionIndex = this.selectedProduct.options_with_values
              .findIndex(({ values }) => values
                  .find(x => x === option));
            let thisOptionSet = [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')].map(({ value }) => value);
            thisOptionSet[optionIndex] = option;
                                    
            if (optionType.toLowerCase().trim() === 'size') {
              this.selectedSize = option;
            }
            if (optionType.toLowerCase().trim() === 'length') {
              this.selectedLength = option;
            }
            this.currentVariant = this.selectedProduct.variants
            .find(({ options }) => options.every((x) => thisOptionSet.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));
            
            this.populateSelectedProductPrice();
            this.enableOrDisableOptionSelects();
            this.swapOutATC();
            window.dispatchEvent(this.variantUpdatedEvent);

            if (!this.currentVariant) return;
            this.displaySku.forEach(sku => sku.innerHTML = this.currentVariant.sku.split('|')[0]);
            this.mainSelect.value = this.currentVariant.id;   
          break;
          case 'notify':
            let drawer = document.querySelector('drawer-modal');
            setTimeout(() => {
              let list = drawer.querySelector('#klaviyo-bis-variant-'+this.selectedProduct.id);
              list.value = this.currentVariant.id
            }, 200);
          break;
          default: break;
        }
      })
    }
    
    
    
    createCustomEvents() {
      this.addToCartEvent = new CustomEvent('quickbuy:add-to-cart', {});
      this.productUpdatedEvent = new CustomEvent('quickbuy:product-updated', {});
      this.variantUpdatedEvent = new CustomEvent('quickbuy:variant-updated', {});
    }
    
    
    enableOrDisableOptionSelects() {
      if (!this.selectedProduct || !Array.isArray(this.selectedProduct.variants)) return;

      const normalize = (s) => (s ?? '').toString().toLowerCase().trim();

      const selectedByIndex = [];
      const checkedInputs = [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')];
      checkedInputs.forEach(({ value }) => {
        const index = this.selectedProduct.options_with_values?.findIndex(({ values }) => values?.some((v) => normalize(v) === normalize(value))) ?? -1;
        if (index > -1) selectedByIndex[index] = value;
      });

      const availableOptionSets = this.selectedProduct.variants.filter((v) => v?.available).map((v) => v.options || []);

      const optionSelects = [...this.querySelectorAll('[data-option]')];
      optionSelects.forEach((select) => {
        const optionValue = select.dataset.option;
        const optionIndex = this.selectedProduct.options_with_values?.findIndex(({ values }) => values?.some((v) => normalize(v) === normalize(optionValue))) ?? -1;

        const candidate = [...selectedByIndex];
        if (optionIndex > -1) candidate[optionIndex] = optionValue;

        const required = candidate.filter(Boolean); 
        const isAvailable = availableOptionSets.some((set) =>
          required.every((sel) => set.some((opt) => normalize(opt) === normalize(sel)))
        );

        const group = select.closest('.group');
        if (group) group.classList.toggle('unavailable', !isAvailable);
      });

      const required = selectedByIndex.filter(Boolean);
      const colorGroups = [...this.querySelectorAll('[data-color-group]')];

      if (required.length === 0) {
        colorGroups.forEach((group) => {
          group.querySelectorAll('[data-action="product-select"][data-product-id]')
            .forEach((input) => {
              input.closest('li')?.classList.remove('oos');
              input.setAttribute('aria-disabled', 'false');
            });
        });
        return;
      }

      colorGroups.forEach((group) => {
        const swatchInputs = [...group.querySelectorAll('[data-action="product-select"][data-product-id]')];

        swatchInputs.forEach((input) => {
          const li = input.closest('li');
          if (!li) return;

          const productId = String(input.dataset.productId || '');
          const product = this.products?.find((product) => String(product.id) === productId);

          if (!product || !Array.isArray(product.variants)) {
            li.classList.remove('oos');
            input.setAttribute('aria-disabled', 'false');
            return;
          }

          const hasMatch = product.variants.some((variant) =>
            variant?.available && required.every((sel) =>
              (variant.options || []).some((opt) => normalize(opt) === normalize(sel))
            )
          );

          li.classList.toggle('oos', !hasMatch);
          input.setAttribute('aria-disabled', (!hasMatch).toString());
        });
      });
    }
    
    populateSelectedProductPrice() {
      if (!this.currentVariant || !this.displayPrice) return;
      this.displayPrice.forEach(el => {
        if (el.dataset.displayPrice === 'simple') {
          el.innerHTML = this.currentVariant?.price_money;
          return;
        }
        
        el.innerHTML = this.currentVariant?.compare_at_price > this?.currentVariant?.price 
          ? `
            <span class="font-medium line-through opacity-60 ${el.dataset.mobileProductContent ? `text-base` : `text-lg`}">${this.currentVariant?.compare_at_price_money}</span>
            <span class="font-medium text-crimsonRed -order-1 ${el.dataset.mobileProductContent ? `text-base` : `text-lg`}">${this.currentVariant?.price_money}</span>`
          : 
            `<span class="font-medium ${el.dataset.mobileProductContent ? `text-base` : `text-lg`}">${this.currentVariant?.price_money}</span>`;
      });
    } 
    
    populateSelectedProductOptions() {
      if (!this.displayOptions || !this.selectedProduct || !this.currentVariant) return;
      
      const optionsHTMLString = this.selectedProduct.options_with_values.map(({ name, values }) => {
        if (values.length < 1) return;
        return `
          <div>
            <div class="flex items-center justify-between gap-4 pb-3.5">
              <strong class="text-xs uppercase">${name}</strong>
            </div>
            <div class="flex flex-wrap items-center gap-2">
              <ul class="inline-flex flex-wrap gap-1">
                ${values.map((value) => {
                  const available = this.selectedProduct.variants.find(({ available, options }) => available && options.find((x) => x == value));
                  let checkedValue;
                  if (this.selectedSize) {
                    checkedValue = (this.selectedSize === value);
                  }
                  if (this.selectedLength && !checkedValue) {
                    checkedValue = (this.selectedLength === value);
                  }
                  if (!checkedValue) {
                    checkedValue = this.currentVariant.options.find((x) => x === value)
                  }
                  return `
                    <li>
                      <div class="${available ? '' : 'unavailable'} group [&.unavailable]:opacity-50 rounded-[30px] flex items-center gap-2 justify-center relative flex-shrink">
                        <input 
                          data-action="option-choice"
                          data-option="${value}"
                          data-option-type="${name}"
                          id="${this.selectedProduct.id}-${value}" 
                          type="radio"
                          class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer opacity-0 peer" 
                          value="${value}"
                          name="${name}"
                          ${checkedValue ? 'checked' : ''}
                        >
                        <span 
                          class="
                            border 
                            duration-200 
                            flex 
                            items-center 
                            justify-center 
                            py-2
                            pl-2
                            pr-4
                            rounded-[30px] 
                            text-primaryDark 
                            border-secondaryDark
                            group-[.unavailable]:line-through
                            transition-all
                            z-1 
                            peer-hover:text-primaryDark 
                            peer-checked:text-primaryDark
                            peer-checked:[&_.icon]:scale-100
                            peer-checked:[&_.icon]:opacity-100
                            peer-checked:gap-2
                            peer-checked:border-current
                            peer-checked:bg-primaryLight
                            peer-checked:px-4
                          "
                        >        
                          <span aria-hidden="true" class="block h-2 w-2 scale-0 opacity-0 rounded-full bg-primaryDark transition-all duration-200 icon"></span>
                          <span class="block font-semibold">${value}</span>
                        </span>                      
                      </div>
                    </li>
                `
                }).join('')}
              </ul>
            </div>
          </div>`
      }).join('')
      this.displayOptions.innerHTML = optionsHTMLString;
    }

    populateSelectedProductImages() {
      this.imagesWrapper.innerHTML = `
        <intersection-loader 
          data-url="/products/${this.selectedProduct.handle}" 
          data-section-id="quickbuy-gallery"
        >
          ${this.imagesWrapper.innerHTML}
        </intersection-loader>
      `;
    }
  
      
    swapOutATC() {
      const atcButton = this.querySelector('[data-action="add-to-cart"]'),
            oosButton = this.querySelector('[data-out-of-stock]'),
            bisButtons = this.querySelectorAll('[data-notify-me]'),
            // stickyATC = document.querySelector('[data-atc-scroll-desktop]'),
            altFinder = this.querySelectorAll('[data-alt-finder]');
      
      if (!this.currentVariant) {
        atcButton.setAttribute('disabled', true);
        if (!oosButton) return;
        bisButtons.forEach(button => button.classList.remove('peer-disabled:block'));
        oosButton.classList.add('peer-disabled:block');
        oosButton.innerHTML = "Unavailable";
        return;
      }
        
      this.currentVariant.available ? atcButton.removeAttribute('disabled') : atcButton.setAttribute('disabled', true);
      // this.currentVariant.available ? stickyATC.innerHTML = "Add to Bag" : stickyATC.innerHTML = "Notify Me";
      this.currentVariant.available ? altFinder.forEach(button => button.classList.add('hidden')) : altFinder.forEach(button => button.classList.remove('hidden'));
      oosButton.innerHTML = "Unavailable";

      const hideBis = !!this.selectedProduct.tags.find(x => x === 'hide_bis');
      if (hideBis) {
        oosButton?.classList.add('peer-disabled:block');
        bisButtons.forEach(button => button.classList.remove('peer-disabled:block'));
      } else {
        oosButton?.classList.remove('peer-disabled:block');
        bisButtons.forEach(button => button.classList.add('peer-disabled:block'));
      }
    }

    trackHistory(initialProductId) {
      const maxHistoryLength = 10;
      const history = JSON.parse(localStorage.getItem('viewhHistory') || '[]');
      if (!history.includes(initialProductId) ) {
        const isHistoryMaxed = history.length === maxHistoryLength;
        const workingHistory = isHistoryMaxed ? history.slice(1) : history;
        const updatedHistory = workingHistory.concat(initialProductId);
      
        localStorage.setItem('viewhHistory', JSON.stringify(updatedHistory));
      }
    }
  }

  customElements.define('quick-shuffle', QuickShuffle);
}
